import { render, staticRenderFns } from "./LffCgv.vue?vue&type=template&id=650dc630&"
import script from "./LffCgv.vue?vue&type=script&lang=js&"
export * from "./LffCgv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports